import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import { useLocation, useNavigate } from "react-router-dom";
import ApplyBtn from "../Components/ApplyBtn";
import MoreBtn from "../Components/MoreBtn";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmApply from "../Modals/AlarmApply";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { showToast } from "../Utils/variables";

const BannerManageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [total_banner, setTotal_banner] = useState(0);
  const [banner_list, setBanner_list] = useState([]);

  const [nation, setNation] = useState("");
  const [page, setPage] = useState(1);
  const offset = 10;
  const [searchTitle, setSearchTitle] = useState("");
  const [bannerId, setBannerId] = useState(null);

  const [clickDelete, setClickDelete] = useState(false);
  const [clickInput, setClickInput] = useState(false);
  const lastBannerRequestKey = useRef(null);

  const getBannerList = async () => {
    try {
      let cCode = nation === "국내" ? "kr" : nation === "국외" ? "99" : null;
      const body = {
        page,
        offset,
        searchTitle,
        cCode,
      };
      const data = await postJson("/dashboard/banner/getList", body, navigate);

      if (data.code === 200) {
        setTotal_banner(data.data.count);
        setBanner_list(data.data.rows);
      }
    } catch (error) {
      console.log("배너리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const handleDeleteBanner = async (bannerId) => {
    try {
      const body = { bannerId };
      const data = await postJson("/dashboard/banner/delete", body, navigate);

      if (data.code === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log("배너 삭제 중 에러:", error);
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ page, nation });

    if (lastBannerRequestKey.current === requestKey) {
      return;
    }

    lastBannerRequestKey.current = requestKey;
    getBannerList();
  }, [page, nation]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("배너가 등록되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div>
      {clickDelete && (
        <AlarmApply
          title="항목을 삭제하시겠습니까?"
          subtitle="삭제하면 앱과 대시보드 내에서 해당 데이터가 영구적으로 사라집니다."
          handleApply={() => handleDeleteBanner(bannerId)}
          handleClickX={() => setClickDelete(false)}
        />
      )}
      <BannerBox>
        {/* 배너 관리 박스 */}
        <div className="title-in-box">배너 관리</div>
        {/* 검색창 | 드롭다운 옵션 | 등록하기 버튼 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="배너명"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getBannerList();
                }
              }}
            />
            <IconSearch style={{ cursor: "pointer" }} onClick={getBannerList} />
          </div>

          {/* 드롭다운 옵션 */}
          <div style={{ display: "flex", marginLeft: "auto" }}>
            <DropdownOption
              title="노출 국가"
              dropdown_list={["국내", "국외"]}
              optionChange={(value) => setNation(value)}
            />

            {/* 등록하기 버튼 */}
            <ApplyBtn addr="/banner/apply" />
          </div>
        </div>

        {/* 전체 배너 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_banner?.toLocaleString()}건
        </div>

        {/* 배너 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns:
                // "100px 140px 330px 220px 220px 220px 140px 350px",
                "100px 140px 330px 220px 220px 140px 350px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">배너이미지</p>
            <p className="leftalign">배너명</p>

            {/* <p className="leftalign">배너 노출 기간</p> */}
            <p className="leftalign">등록일</p>
            <p className="leftalign">노출 국가</p>
          </div>

          {/* 데이터 */}
          {banner_list.slice(0, 10).map((data) => (
            <BannerData
              key={data.rownum}
              rownum={data.rownum}
              mainImage={data.mainImage}
              title={data.title}
              regTime={data.regTime}
              cCode={data.cCode}
              bannerId={data.bannerId}
              setClickDelete={setClickDelete}
              setBannerId={setBannerId}
            />
          ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_banner === 0 ? 1 : Math.ceil(total_banner / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </BannerBox>
    </div>
  );
};

const BannerData = ({
  rownum,
  mainImage,
  title,
  regTime,
  cCode,
  bannerId,
  setClickDelete,
  setBannerId,
}) => {
  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns:
          // "100px 140px 330px 220px 220px 140px 298px 52px",
          "100px 140px 330px 220px 140px 518px 52px",
      }}
    >
      <p className="center">{rownum?.toLocaleString()}</p>
      <div className="leftalign">
        {mainImage ? (
          <div className="emptyImage" style={{ width: "112px" }}>
            <img
              style={{ width: "100%", height: "100%" }}
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${mainImage}`}
            />
          </div>
        ) : (
          <div className="emptyImage" />
        )}
      </div>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{title}</p>
      </div>
      {/* <p className="leftalign">{bannerDate}</p> */}
      <p className="leftalign">{regTime}</p>
      <p className="leftalign">{cCode === "kr" ? "국내" : "국외"}</p>
      <div />
      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          option1Addr={`/banner/edit/${bannerId}`}
          optionClickDelete={() => {
            setClickDelete(true);
            setBannerId(bannerId);
          }}
        />
      </div>
    </div>
  );
};

const BannerBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px;
`;

const BannerManage = () => {
  return <Layout page={<BannerManageContent />} />;
};

export default BannerManage;
